<template>
  <div>
    <h2 v-if="showTitle">{{ $t(electionLocations.pollType) }}</h2>
    <div v-if="voteAnywhereWarning" class="alert alert-warning mt-3" role="alert" v-html="$t('vote-anywhere-warning')"></div>
    <ElectionLocation v-for="(location, index) in displayLocations" :key="index" :location="location"></ElectionLocation>
    <p v-if="showMore"><button class="btn btn-outline-secondary" @click="show_all = true">{{ $t('show-more') }}</button></p>
  </div>
</template>

<script>

import ElectionLocation from '@/components/ElectionLocation.vue';

export default {
  data() {
    return {
      show_all: false,
    }
  },

  components: { ElectionLocation },

  props: ['electionLocations','showTitle', 'voteAnywhereWarning'],

  computed: {

    displayLocations() {
      if (this.electionLocations.locations && (this.electionLocations.locations.length > this.electionLocations.limit) && !this.show_all ) {
        return this.electionLocations.locations.slice(0,this.electionLocations.limit);
      } else {
        return this.electionLocations.locations;
      }
    },

    showMore() {
        return ((this.electionLocations.locations.length > this.electionLocations.limit) && !this.show_all);
    },

  }

}
</script>
